// @ts-check

import { createContext, useContext, useMemo } from "react";
import {safeSlug} from "@service/scripts/components/helpers.jsx";

const RichTextContext = createContext(undefined);

export const RichTextProvider = ({ children, cdaEntry, }) => {
	const headings = cdaEntry.fields.text?.content
		.filter(node => node.nodeType.startsWith("heading-"))
		.map(node => {
			return ({
				id: safeSlug(node.content[0].value),
				text: node.content[0].value
			});
		});

	const value = useMemo(
		() => ({
			headings
		}),
		[headings],
	);

	return (
		<RichTextContext.Provider value={value}>
			{children}
		</RichTextContext.Provider>
	);
};

/**
 * Check for undefined since the defaultValue of the context is undefined. If
 * it's still undefined, the provider component is missing.
 */
export function useRichTextContext() {
	const context = useContext(RichTextContext);
	if (!context) throw new Error("Provider missing!");
	return context;
}
